import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Title from './title-model'
import {
  CreateTitleAsync,
  DeleteTitleAsync,
  LoadTitlesAsync,
} from './title-thunk'
const initialState: titleSliceState = {
  title: [],
  selected_title: '',
  is_loading_title: false,
  is_creating_title: false,
  is_deleting_title: false,
}
export interface titleSliceState {
  title: Title[]
  selected_title?: string
  is_loading_title: boolean
  is_creating_title: boolean
  is_deleting_title: boolean
}
export const titleSlice = createSlice({
  name: 'title',
  initialState,
  reducers: {
    setSelectedtitle: (state, action) => {
      state.selected_title = action.payload
    },
    clearStatetitle: (state) => {
      state.title = []
      state.is_loading_title = false
      state.is_creating_title = false
      state.is_deleting_title = false
    },
    mergetitle: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_title = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.title = merge(state.title, payload) as any
        }
      }
    },

    add_title: (state, action) => {
      if (action.payload) {
        state.title = [...state.title, action.payload]
      }
    },
    set_title: (state, action) => {
      let { key, value, id } = action.payload
      state.title = state.title.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadTitlesAsync.pending, (state) => {
      state.is_loading_title = true
    })
    builder.addCase(LoadTitlesAsync.fulfilled, (state, action) => {
      state.is_loading_title = false
      if (action.payload) {
        state.title = action.payload
      }
    })
    builder.addCase(LoadTitlesAsync.rejected, (state) => {
      state.is_loading_title = false
    })
    builder.addCase(CreateTitleAsync.pending, (state) => {
      state.is_creating_title = true
    })
    builder.addCase(CreateTitleAsync.fulfilled, (state) => {
      state.is_creating_title = false
    })
    builder.addCase(CreateTitleAsync.rejected, (state) => {
      state.is_creating_title = false
    })
    builder.addCase(DeleteTitleAsync.pending, (state) => {
      state.is_deleting_title = true
    })
    builder.addCase(DeleteTitleAsync.fulfilled, (state, action) => {
      state.is_deleting_title = false
      if (state.title) {
        state.title = state.title.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteTitleAsync.rejected, (state) => {
      state.is_deleting_title = false
    })
  },
})

export const {
  clearStatetitle,
  setSelectedtitle,
  set_title,
  mergetitle,
  add_title,
} = titleSlice.actions

export const get_title =
  (id?: string) =>
  (state: {
    title: {
      title: Title[]
    }
  }): Title | null => {
    let temp = state?.title?.title?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.title?.title[0] || null
  }
export const get_selected_title = (state: {
  title: titleSliceState
}): Title | null => {
  let id = state?.title?.selected_title
  let temp = state?.title?.title?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_title = (state: {
  title: {
    title: Title[]
  }
}): Title[] => {
  let temp = state?.title?.title
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_title_busy = (state: { title: titleSliceState }) => {
  return (
    state?.title.is_deleting_title ||
    state?.title.is_loading_title ||
    state?.title.is_creating_title
  )
}
export const is_deleting_title_busy = (state: { title: titleSliceState }) => {
  return state?.title.is_deleting_title
}
export const is_loading_title_busy = (state: { title: titleSliceState }) => {
  return state?.title.is_loading_title
}
export const is_creating_title_busy = (state: { title: titleSliceState }) => {
  return state?.title.is_creating_title
}

export default titleSlice.reducer
